webpackJsonp([6,14],{

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(584);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _classnames = __webpack_require__(133);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ooRoutes = __webpack_require__(24);
	
	var _ooConfig = __webpack_require__(140);
	
	var _ooConfig2 = _interopRequireDefault(_ooConfig);
	
	var _http = __webpack_require__(66);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _Page2 = __webpack_require__(591);
	
	var _Page3 = _interopRequireDefault(_Page2);
	
	var _Radio = __webpack_require__(611);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _Message = __webpack_require__(599);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _user = __webpack_require__(719);
	
	var _util = __webpack_require__(598);
	
	__webpack_require__(744);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PERSONAS_SELECTIONS = [{
	  display: 'E-commerce storeowner',
	  value: _user.PERSONAS.ECOMMERCE
	}, {
	  display: 'Promotional products distributor',
	  value: _user.PERSONAS.PROMOTIONAL
	}, {
	  display: 'Other',
	  value: _user.PERSONAS.OTHER
	}];
	
	var SALES_SELECTIONS = [{
	  display: 'Less than $250,000',
	  value: 'less-than-250k'
	}, {
	  display: '$250,000 to $500,000',
	  value: '250k-500k'
	}, {
	  display: '$500,000 to $1,000,000',
	  value: '500k-1m'
	}, {
	  display: 'Over $1,000,000',
	  value: 'over-1m'
	}];
	
	var PRINT_TYPE_SELECTIONS = [{
	  display: 'Screenprint',
	  value: 'screenprint',
	  imageUrl: __webpack_require__(682)
	}, {
	  display: 'DTG',
	  value: 'dtg',
	  imageUrl: __webpack_require__(679)
	}, {
	  display: 'Embroidery',
	  value: 'embr',
	  imageUrl: __webpack_require__(601)
	}, {
	  display: 'Posters',
	  value: 'poster',
	  imageUrl: __webpack_require__(681)
	}, {
	  display: 'Sublimation',
	  value: 'sublimation',
	  imageUrl: __webpack_require__(680)
	}];
	
	var TERMS_URL = 'https://scalablepress.com/company/terms';
	
	function loadIntlInput() {
	  var phoneInputField = document.querySelector("#phone");
	  var phoneInput = window.intlTelInput(phoneInputField, {
	    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
	  });
	  window.phoneInput = phoneInput;
	}
	
	var RegisterPage = function (_Page) {
	  _inherits(RegisterPage, _Page);
	
	  function RegisterPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RegisterPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegisterPage.__proto__ || Object.getPrototypeOf(RegisterPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      form: {
	        printTypes: _lodash2.default.reduce(PRINT_TYPE_SELECTIONS, function (printTypes, selection) {
	          var newPrintTypes = printTypes;
	          newPrintTypes[selection.value] = false;
	          return newPrintTypes;
	        }, {}) // Evalueates to { dtg: false, embr: false, etc...}
	      },
	      phoneValidation: {},
	      errors: {}
	    }, _this.clearMessage = function () {
	      return function () {
	        return _this.setState({ message: null });
	      };
	    }, _this.submitPhoneValidation = function () {
	      return function (event) {
	        event.preventDefault();
	        if (!phoneInput.isValidNumber()) {
	          return _this.setState({ message: { error: "Invalid phone number" } });
	        }
	        var phoneNumber = phoneInput.getNumber();
	        var form = Object.assign({}, _this.state.form, { 'phone': phoneNumber });
	
	        _this.setState({ phoneValidationLoading: true, form: form });
	        _http2.default.post((0, _ooRoutes.url)('website', _ooRoutes.routes.website.auth.twilio.createVerificationSms), { body: { phone: phoneNumber } }, function (err, result) {
	          _this.setState({ phoneValidationLoading: false, validationStarted: true });
	        });
	      };
	    }, _this.updateField = function (field) {
	      return function (event) {
	        var form = Object.assign({}, _this.state.form, _defineProperty({}, field, event.target.value));
	        _this.setState({ form: form });
	      };
	    }, _this.updateFieldValue = function (field) {
	      return function (value) {
	        var form = Object.assign({}, _this.state.form, _defineProperty({}, field, value));
	        _this.setState({ form: form });
	      };
	    }, _this.togglePrintType = function (field) {
	      return function () {
	        var form = Object.assign({}, _this.state.form);
	        Object.assign(form.printTypes, _defineProperty({}, field, !form.printTypes[field]));
	        _this.setState({ form: form });
	      };
	    }, _this.submit = function (form) {
	      return function () {
	        _this.setState({ loading: true });
	        var errors = (0, _util.validateUserRegistration)(form);
	        if (Object.keys(errors).length > 0) return _this.setState({ errors: errors, loading: false });
	
	        _this.setState({ errors: errors, message: null });
	        return _http2.default.post((0, _ooRoutes.url)('website', _ooRoutes.routes.website.auth.register, Object.assign({}, _this.props.location.query)), { body: form }, function (err, result) {
	          if (err || !result) {
	            var message = { error: err.message || err || 'Unknown error communicating with server' };
	            return _this.setState({ loading: false, message: message });
	          }
	
	          if (Appcues) {
	            Appcues.identify(result._id, {
	              name: result.name,
	              email: result.email,
	              created_at: result.createdAt
	            });
	            Appcues.track("registration", {
	              persona: _this.state.form.persona,
	              email: _this.state.form.email,
	              sales: _this.state.form.sales
	            });
	          }
	          if (fbq) {
	            fbq('track', 'CompleteRegistration');
	          }
	
	          window.location.href = (0, _ooRoutes.url)('website', _ooRoutes.routes.website.auth.success, { redirect: (0, _ooRoutes.url)('manager', _ooRoutes.routes.manager.new) });
	          return _this.setState({ message: { success: 'Successfully logged in, redirecting...' } });
	        });
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RegisterPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      loadIntlInput();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          form = _state.form,
	          errors = _state.errors,
	          message = _state.message,
	          loading = _state.loading;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RegisterPage' },
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: 'Register'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui container p-t-4 p-b-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-aligned' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'REQUEST AN ACCOUNT'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'fs-2' },
	              'Get started with a Scalable Press account.'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'p-v-2' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ui centered grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui nine wide computer twelve wide tablet twelve wide mobile column' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui raised segments' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui segment p-h-2 step-header' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'fs-3' },
	                    'User Details'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui segment p-h-2' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'ui form' },
	                    message && _react2.default.createElement(
	                      'div',
	                      { className: 'm-v-1' },
	                      _react2.default.createElement(_Message2.default, {
	                        message: message,
	                        closable: true,
	                        dismiss: this.clearMessage()
	                      })
	                    ),
	                    Object.keys(errors).length > 0 && _react2.default.createElement(
	                      'div',
	                      { className: 'ui message error' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'header' },
	                        'Please fix these issues:'
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list' },
	                        _lodash2.default.map(errors, function (error, field) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: field },
	                            error
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'two fields' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('field', { error: errors.first_name }) },
	                        _react2.default.createElement('input', { type: 'text', onChange: this.updateField('first_name'), placeholder: 'First Name' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('field', { error: errors.last_name }) },
	                        _react2.default.createElement('input', { type: 'text', onChange: this.updateField('last_name'), placeholder: 'Last Name' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('field', { error: errors.email }) },
	                      _react2.default.createElement('input', { type: 'text', onChange: this.updateField('email'), placeholder: 'Email' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'two fields' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('field', { error: errors.password }) },
	                        _react2.default.createElement('input', { type: 'password', onChange: this.updateField('password'), placeholder: 'Choose a password' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('field', { error: errors.confirm }) },
	                        _react2.default.createElement('input', { type: 'password', onChange: this.updateField('confirm'), placeholder: 'Password, again' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('field', { error: errors.company }) },
	                      _react2.default.createElement('input', { type: 'text', placeholder: 'Company Name' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'two fields' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'field' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'container' },
	                          _react2.default.createElement(
	                            'form',
	                            { id: 'login', onSubmit: this.submitPhoneValidation() },
	                            _react2.default.createElement('input', { id: 'phone', type: 'tel', onChange: this.updateField('phone'), name: 'phone', style: { paddingLeft: "3.25rem" } }),
	                            !this.props.location.query.internalEmployee && !this.props.location.query.onboard && _react2.default.createElement('input', { type: 'submit', value: 'Get code', style: { padding: "0.75rem", verticalAlign: "bottom", marginLeft: "0.5rem" } })
	                          )
	                        )
	                      ),
	                      this.state.validationStarted && _react2.default.createElement(
	                        'div',
	                        { className: 'field' },
	                        _react2.default.createElement('input', { type: 'text', onChange: this.updateField('phoneCode'), placeholder: 'Phone validation code' })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui segment p-h-2' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      onClick: this.submit(form),
	                      className: (0, _classnames2.default)('ui primary button m-b-2 create-account-button', { loading: loading })
	                    },
	                    'Create Account'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'secondary-text m-l-1' },
	                    'By creating an account, you are agreeing to the ',
	                    _react2.default.createElement(
	                      'a',
	                      { href: TERMS_URL },
	                      'terms and conditions'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'bottom-aligned' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'secondary-text' },
	                      'Already have an account? ',
	                      _react2.default.createElement(
	                        'a',
	                        { href: (0, _ooRoutes.url)('website2', _ooRoutes.routes.website2.home.auth.login) },
	                        'Login'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RegisterPage;
	}(_Page3.default);
	
	exports.default = RegisterPage;

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	var ALPHA_TEST_USER_ID, BLOCK_MESSAGE, BLOCK_READABLE, BLOCK_REASONS, EMAIL_REGEX, OOSHIRTS_USER_ID, TEECHIP_USER_ID, _, normalizeEmail, obj, obj1, validEmail;
	
	_ = __webpack_require__(17);
	
	exports.OOSHIRTS_USER_ID = OOSHIRTS_USER_ID = '57a26d2a7470cb473a565dae';
	
	exports.TEECHIP_USER_ID = TEECHIP_USER_ID = '57746a4644a695ad11537433';
	
	exports.ALPHA_TEST_USER_ID = ALPHA_TEST_USER_ID = '59a72815b7db791512451646';
	
	exports.ALPHA_USER_ID = ALPHA_TEST_USER_ID = '589e2be57a1a4fe7022458b5';
	
	exports.PERSONAS = {
	  PROMOTIONAL: 'promotional',
	  ECOMMERCE: 'e-commerce',
	  OTHER: 'other'
	};
	
	exports.BLOCK_REASONS = BLOCK_REASONS = {
	  OVERDUE_INVOICES: 'overdue-invoices'
	};
	
	exports.BLOCK_REASONS_LIST = _.values(BLOCK_REASONS);
	
	exports.BLOCK_READABLE = BLOCK_READABLE = (
	  obj = {},
	  obj["" + BLOCK_REASONS.OVERDUE_INVOICES] = "overdue invoices",
	  obj
	);
	
	exports.BLOCK_MESSAGE = BLOCK_MESSAGE = (
	  obj1 = {},
	  obj1["" + BLOCK_REASONS.OVERDUE_INVOICES] = "please pay overdue invoices to resume account activity.",
	  obj1
	);
	
	exports.EMAIL_REGEX = EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
	
	exports.validEmail = validEmail = function(email) {
	  return EMAIL_REGEX.test(email);
	};
	
	exports.normalizeEmail = normalizeEmail = function(email) {
	  return email.toLowerCase().trim();
	};


/***/ }),

/***/ 744:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// 6.794baef9177047926915.6.js